import React, { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import moment from "moment";
import { convertDataToBuyingSheet } from '../helpers/print';
import { GETREQUEST, POSTREQUEST } from '../helpers/ServiceRequest';
import { generateBuyingPdf } from '../Pdfs/buyingSheet';
import { generateProductCreditPdf } from '../Pdfs/ProductCredit';
import { generateCrateCreditPdf } from '../Pdfs/CrateCredit';
import { generateInvoicePdf } from '../Pdfs/invoice';
import { generatePurchasePdf } from '../Pdfs/purchaseSheet';

const AllSheetsEmail = () => {
  const { type, id, date } = useParams();
  const [pdfData, setPdfData] = useState([]);
  const token = window.auth;

  const getbuyingSheetData = async (isPurchaseSheet = false) => {
    let buyingSheetURL = process.env.REACT_APP_API_URL + `/email-buying-sheet`;
    let payload = {
      agentId: id,
      fromDate: date,
      vpCodes: "all"
    }
    let response = await POSTREQUEST(buyingSheetURL, payload, token);
    if (response?.data) {
      const data = await convertDataToBuyingSheet(response.data)
      if (isPurchaseSheet) {
        const result = await generatePurchasePdf(data, true);
        const pdfBuffer = Buffer.from(result).toString("base64");
        setPdfData(pdfBuffer);
      } else {
        const result = await generateBuyingPdf(data, true);
        const pdfBuffer = Buffer.from(result).toString("base64");
        setPdfData(pdfBuffer);
      }
    }
  }

  const getInvoiceSheetData = async () => {
    let InvoiceURL = `${process.env.REACT_APP_API_URL}/get-email-invoice/${id}`;
    let response = await GETREQUEST(InvoiceURL, token);
    if (response?.data) {
      const result = await generateInvoicePdf(response.data, true);
      const pdfBuffer = Buffer.from(result).toString("base64");
      setPdfData(pdfBuffer);
    }
  }

  const getProductCreditData = async () => {
    let result = await getProductCredit();
    const pdfBuffer = Buffer.from(result).toString("base64");
    setPdfData(pdfBuffer);
  }

  const getCrateCreditData = async () => {
    let result = await getCrateCredit();
    const pdfBuffer = Buffer.from(result).toString("base64");
    setPdfData(pdfBuffer);
  }

  const getProductCredit = async () => {
    const productCreditURL = process.env.REACT_APP_API_URL + `/get-email-produce-credit/${id} `;

    try {
      const productsCreditResponse = await GETREQUEST(productCreditURL, token, false)
      if (!productsCreditResponse.data) {
        return;
      }

      const productData = productsCreditResponse.data.credit;
      const unitsData = productsCreditResponse.data.units;
      const products = productsCreditResponse.data.products;

      const units = unitsData.map(item => ({
        label: item.UnitName,
        value: item.UnitID,
        ...item
      }));

      const updatedProdDetails = productData?.tblProdCreditDetails?.filter(creditItem =>
        creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== ''
      ).map(creditItem => ({
        ...creditItem,
        ProdCreditAmt: creditItem.ProdCreditAmt ? parseFloat(creditItem.ProdCreditAmt).toFixed(2) : 0,
        ProdCreditGSTAmt: creditItem.ProdCreditGSTAmt ? parseFloat(creditItem.ProdCreditGSTAmt).toFixed(2) : 0,
      })) || [];

      let previewData = {
        CNID: id,
        ReturnDate: moment(productData?.CNDate).format('YYYY-MM-DD'),
        ReferenceNo: productData?.CNReference,
        tblCustomer: productData?.tblCustomer,
        products,
        units,
        creditDetails: updatedProdDetails
      }
      return await generateProductCreditPdf(previewData, true);

    } catch (error) {
      console.error("Error fetching product credit preview:", error);
    }
  }

  const getCrateCredit = async () => {
    const crateCreditURL = `${process.env.REACT_APP_API_URL}/get-email-crate-credit/${id}`;

    try {
      const crateResponse = await GETREQUEST(crateCreditURL, token, false);
      if (!crateResponse.data) {
        return;
      }

      const crateData = crateResponse.data.credit;
      const containersData = crateResponse.data.containers;

      const crList = containersData.map(item => ({
        label: item.TypeInCode,
        value: item.ContainerID,
        ...item
      }));

      const updatedCrateDetails = crateData?.tblCrateCreditDetails?.filter(creditItem =>
        creditItem.Qty !== '' && creditItem.ContainerID !== '' && creditItem.CrateReturnValue !== ''
      ).map(creditItem => ({
        ...creditItem,
        CrateCreditAmt: creditItem.CrateCreditAmt ? parseFloat(creditItem.CrateCreditAmt).toFixed(2) : 0
      })) || [];

      const previewData = {
        CNID: id,
        ReturnDate: moment(crateData?.CNDate).format('YYYY-MM-DD'),
        ReferenceNo: crateData?.CNReference,
        tblCustomer: crateData?.tblCustomer,
        crates: crList,
        creditDetails: updatedCrateDetails
      };

      return await generateCrateCreditPdf(previewData, true);

    } catch (error) {
      console.error("Error fetching crate credit preview:", error);
    }
  };

  useEffect(() => {
    if (type && token) {
      switch (type) {
        case 'buying':
          getbuyingSheetData(false);
          break
        case 'purchase':
          getbuyingSheetData(true);
          break;
        case 'invoice':
          getInvoiceSheetData();
          break;
        case 'produceCredit':
          getProductCreditData();
          break;
        case 'crateCredit':
          getCrateCreditData();
          break;
      }
    }
  }, []);

  return (
    <div id="pdfData">
      {pdfData}
    </div>)
}

export default AllSheetsEmail
